module.exports = __webpack_public_path__ + "img/9.1115d1a5.jpg";